import Big from 'big.js';

const VAT = 1.21;
const BASIC_MARGIN = Big(18); // Price list price or purchase price salons
// const ORDER_COST = Big(3.5); // Order costs B2C order

// Order status as is in firestore database;
const STATUS = {
  PAID: 'paid',
  PAYABLE: 'payable',
  AWAITING: 'awaiting return period',
};

const removePercent = (number, percentage) => {
  const result = number.minus(percentage.div(100).times(number));
  return Big(result);
};

export const getFee = (orderPrice, kickbackFee, orderCost) => {
  if (!orderPrice || !kickbackFee) {
    return 0.0;
  }
  const parsedKickbackFee = Big(kickbackFee);
  const orderTotal = Big(orderPrice);

  const formatedOrderCost = (orderCost || '3.5').toString().replace(',', '.'); // Replace comma with dot
  const ORDER_COST = Big(formatedOrderCost);

  const purchasePrice = orderTotal.div(VAT); // Total price without the VAT. Starting point for calculation

  const priceWithoutMargin = removePercent(purchasePrice, BASIC_MARGIN); // Price list price or purchase price salons

  const netPurchase = removePercent(priceWithoutMargin, parsedKickbackFee);

  const grossMargin = purchasePrice.minus(netPurchase);

  const grossIncome = grossMargin.minus(ORDER_COST);

  if (grossIncome < 0) {
    return 0.0;
  }

  return grossIncome.toFixed(2);
};

const getOrdersByStatus = (items, targetStatus) =>
  items?.filter(item => item.status === targetStatus) || [];

export const calcluateFees = (orders, fee) => {
  const totals = {
    payable: Big(0),
    paid: Big(0),
    awaitingReturnsPeriod: Big(0),
  };

  getOrdersByStatus(orders, STATUS.PAYABLE).forEach(payableItem => {
    totals.payable = totals.payable.add(getFee(payableItem.amount, fee, payableItem.handleCost));
  });

  getOrdersByStatus(orders, STATUS.PAID).forEach(paidItem => {
    totals.paid = totals.paid.add(getFee(paidItem.amount, fee, paidItem.handleCost));
  });

  getOrdersByStatus(orders, STATUS.AWAITING).forEach(awaitingReturnsItem => {
    totals.awaitingReturnsPeriod = totals.awaitingReturnsPeriod.add(
      getFee(awaitingReturnsItem.amount, fee, awaitingReturnsItem.handleCost)
    );
  });

  return {
    payable: totals.payable.toFixed(2),
    paid: totals.paid.toFixed(2),
    awaitingReturnsPeriod: totals.awaitingReturnsPeriod.toFixed(2),
    total: totals.paid.add(totals.payable).toFixed(2),
  };
};
